/**
 * Landing page variant: B — Wall of Outputs
 * Converted from design prototype wireframe JSX.
 */
import { Link } from "react-router-dom";
import { HOME_LINE } from "../public/legal-text.ts";
import {
  WfNavBar, WfFooter, FooterCTA, FaqRow,
  PlayBlob, FakeWaveform, ScriptLines, 
} from "./primitives.tsx";

// Wireframe B — "Wall of Outputs" / Receipts-first
// Anti-SaaS: skip the marketing speak, lead with raw evidence (the videos people shipped).

export function WireframeB() {
  return (
    <div className="wf paper no-tex" style={{ maxWidth: 1280, width: "100%", background: "#0f0f0f", color: "#f0ebde" }}>
      {/* dark variant — different vibe from A */}
      <style>{`
        .wfb a, .wfb { color: #f0ebde; }
        .wfb .pill { background: #1a1a1a; color: #f0ebde; border-color: #f0ebde; }
        .wfb .box { background: #1a1a1a; border-color: #f0ebde; }
        .wfb .box::after { border-color: rgba(240,235,222,0.35); }
        .wfb .btn { background: var(--accent); color: #0f0f0f; box-shadow: 4px 4px 0 0 #f0ebde; border-color:#f0ebde; }
        .wfb .btn.ghost { background: transparent; color: #f0ebde; box-shadow: 4px 4px 0 0 var(--accent); }
        .wfb .mute { color: rgba(240,235,222,0.55); }
        .wfb .thumb { background:#222; border-color:#f0ebde; }
        .wfb .navrow { border-bottom-color:#f0ebde; }
        .wfb .navrow nav a { color:#f0ebde; }
        .wfb .logo .mark { border-color:#f0ebde; }
        .wfb .label { color: rgba(240,235,222,0.6); }
      `}</style>

      <div className="wfb">
      <WfNavBar />

      {/* HERO — kicker stat over a giant marquee of thumbnails */}
      <section style={{ padding: "44px 60px 0", position: "relative" }}>
        <div className="row" style={{ alignItems:"flex-end", justifyContent:"space-between", gap: 40 }}>
          <div>
            <h1 style={{ fontSize: 132, lineHeight: 0.88, letterSpacing: "-2px", maxWidth: 850 }}>
              {/* (owner 2026-10-08 18:15) the headline; the invented "14,892 videos shipped … this month alone" is gone */}
              TYPE A TOPIC.<br />
              <span style={{ color: "var(--accent)" }}>REVIEW EVERY WORD.</span><br />
              POST A FINISHED SHORT.
            </h1>
            {/* (B120-1; D5) the line under the headline */}
            <p data-home-line="" style={{ fontSize: 20, lineHeight: 1.45, maxWidth: 720, margin: "18px 0 0" }}>{HOME_LINE}</p>
          </div>
          <div style={{ maxWidth: 360 }}>
            <div className="type" style={{ fontSize: 22, lineHeight: 1.3, marginBottom: 18 }}>
              <span className="hl" style={{ background:"var(--accent)", color:"#0f0f0f" }}>No demo. No tour.</span>
            </div>
            <div className="col" style={{ gap: 10 }}>
              <Link to="/signup" className="btn" style={{ textDecoration: "none" }}>▶ make one in 9 min</Link>
            </div>
          </div>
        </div>
      </section>


      {/* ANTI-PROMISE STATEMENT */}
      <section style={{ padding: "70px 60px", borderTop: "1px solid rgba(240,235,222,0.15)" }}>
        <div className="row" style={{ alignItems:"flex-start", gap: 40 }}>
          <div style={{ flex: 1 }}>
            <div className="label" style={{ color: "var(--accent)" }}>※ 02 — THE THESIS</div>
            <h2 style={{ fontSize: 78, lineHeight: 0.92, marginTop: 14, maxWidth: 1000 }}>
              Other tools render <span style={{ textDecoration:"line-through", color:"rgba(240,235,222,0.4)" }}>slop</span>.<br />
              <span style={{ color:"var(--accent)" }}>You</span> render whatever you want, because <span className="hl" style={{ background:"var(--accent)", color:"#0f0f0f" }}>you sign every gate</span>.
            </h2>
          </div>
        </div>

        <div style={{ display:"grid", gridTemplateColumns:"repeat(2, 1fr)", gap: 24, marginTop: 40 }}>
          <div className="box flat" style={{ padding: 26 }}>
            <div className="label">GATE 1 — SCRIPT</div>
            <div style={{ fontFamily:"Permanent Marker", fontSize: 36, lineHeight: 0.95, marginTop: 8 }}>Every word lives or dies by your cursor.</div>
            <div style={{ marginTop: 18 }}>
              <div style={{ background:"#0f0f0f", padding: 16, border:"1px dashed #f0ebde", position:"relative" }}>
                <div className="label" style={{ fontSize: 9 }}>SEGMENT 04 · "the hook"</div>
                <div className="type" style={{ marginTop: 8, fontSize: 18, lineHeight: 1.4 }}>
                  In 1956, Soviet scientists strapped a stray dog to a rocket. <span style={{ background:"var(--accent)", color:"#0f0f0f", padding:"0 4px" }}>her name was Laika.</span> What happened next changed —
                </div>
                <div className="anno" style={{ right: 16, top: 8, color: "var(--accent)", fontFamily:"Caveat", fontSize: 22, transform: "none" }}>edit me ✎</div>
              </div>
            </div>
          </div>
          <div className="box flat" style={{ padding: 26 }}>
            <div className="label">GATE 2 — STORYBOARD</div>
            <div style={{ fontFamily:"Permanent Marker", fontSize: 36, lineHeight: 0.95, marginTop: 8 }}>Every frame, in your hands first.</div>
            <div style={{ marginTop: 18, display:"grid", gridTemplateColumns:"repeat(4, 1fr)", gap: 8 }}>
              {Array.from({ length: 8 }).map((_,i) =>
                <div key={i} className="thumb" style={{ height: 60, background: i===3 ? "var(--accent)" : "#222" }}>
                  {i===3 && <div style={{ position:"absolute", top:2, right:4, color:"#0f0f0f", fontFamily:"Caveat", fontSize:14, zIndex:3 }}>regen ↻</div>}
                </div>
              )}
            </div>
            <div className="hand mute" style={{ marginTop: 12, fontSize: 18 }}>↑ tap to regenerate · drag to reorder · ⌘Z to undo</div>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <a id="how-it-works" />
      <section style={{ padding: "70px 60px", borderTop: "1px solid rgba(240,235,222,0.15)", background:"#161616" }}>
        <div className="label" style={{ color:"var(--accent)" }}>※ 03 — THE 9-MINUTE LOOP</div>
        <h2 style={{ fontSize: 64, marginTop: 14 }}>FOUR THINGS HAPPEN. THAT'S THE WHOLE TOOL.</h2>
        <div style={{ marginTop: 36, display:"grid", gridTemplateColumns:"60px 1fr 1fr 1fr 1fr", alignItems:"flex-start", gap: 20 }}>
          <div className="label" style={{ alignSelf:"end", paddingBottom: 8 }}>00:00</div>
          {[
            ["PICK","Niche preset. Voice + image + caption style locked in."],
            ["WRITE","AI drafts. You red-pen. Regen by the line, not the page."],
            ["FRAME","Each segment → AI image. Reject anything that doesn't fit."],
            ["SHIP","1080p MP4. Or direct YouTube push. Or schedule. Or all three."],
          ].map(([t,d],i) => (
            <div key={t} style={{ position:"relative" }}>
              <div className="display-xl" style={{ fontSize: 96, lineHeight: 0.85, color:"rgba(240,235,222,0.08)", letterSpacing: "-0.04em" }}>{String(i+1).padStart(2,"0")}</div>
              <div className="display" style={{ fontSize: 26, marginTop: -42, position:"relative" }}>{t}</div>
              <div className="type mute" style={{ marginTop: 8, fontSize: 16, lineHeight: 1.4 }}>{d}</div>
              <div className="label" style={{ marginTop: 14 }}>{["≈ 5s","≈ 20s","≈ 90s","≈ 4-8m"][i]}</div>
            </div>
          ))}
        </div>
      </section>

      {/* LIVE PEEK — split: code-y left, pretty right */}
      <section style={{ padding: "70px 60px", borderTop: "1px solid rgba(240,235,222,0.15)" }}>
        <div className="row" style={{ alignItems:"flex-end", justifyContent:"space-between", marginBottom: 24 }}>
          <div>
            <div className="label" style={{ color:"var(--accent)" }}>※ 04 — PEEK INSIDE</div>
            <h2 style={{ fontSize: 60, marginTop: 10, lineHeight: 0.95 }}>SCRIPT &nbsp;→&nbsp; STORYBOARD &nbsp;→&nbsp; RENDER.</h2>
          </div>
          <div className="hand mute" style={{ fontSize: 22 }}>(autoplays, hover to scrub)</div>
        </div>
        <div className="row" style={{ gap: 18 }}>
          <div className="box flat" style={{ flex: 1, padding: 22 }}>
            <div className="label">01 · INPUT</div>
            <div style={{ marginTop: 12, fontFamily:"Permanent Marker", fontSize: 28 }}>"why monks lived in caves"</div>
            <div className="row" style={{ gap: 6, marginTop: 14, flexWrap:"wrap" }}>
              {["history/long-form","9-12 min","male narrator","cinematic"].map(t => <span key={t} className="pill" style={{ fontSize: 11 }}>{t}</span>)}
            </div>
          </div>
          <div className="box flat" style={{ flex: 1.2, padding: 22 }}>
            <div className="label">02 · SCRIPT</div>
            <div style={{ marginTop: 12 }}>
              <ScriptLines lines={6} />
              <div className="row" style={{ marginTop: 12, gap: 8, alignItems:"center" }}>
                <FakeWaveform width={200} height={22} bars={28} seed={7} />
                <span className="label">11:24</span>
              </div>
            </div>
          </div>
          <div className="box flat" style={{ flex: 1.4, padding: 22 }}>
            <div className="label">03 · RENDER</div>
            <div className="thumb" style={{ marginTop: 12, height: 140, background:"#222" }}>
              <div style={{ position:"absolute", inset:0, display:"flex", alignItems:"center", justifyContent:"center", zIndex:3 }}>
                <PlayBlob size={50} />
              </div>
            </div>
            <div className="row" style={{ gap: 8, marginTop: 12, justifyContent:"space-between" }}>
              <span className="pill" style={{ fontSize: 11 }}>↓ mp4 · 187MB</span>
              <span className="pill" style={{ fontSize: 11, background:"var(--accent)", color:"#0f0f0f" }}>▶ publish to yt</span>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <a id="faq" />
      <section style={{ padding:"70px 60px", borderTop: "1px solid rgba(240,235,222,0.15)", background:"#161616" }}>
        <div className="label" style={{ color: "var(--accent)" }}>※ 05 — STILL SUSPICIOUS</div>
        <h2 style={{ fontSize: 60, marginTop: 10 }}>FAIR. ASK AWAY.</h2>
        <div style={{ marginTop: 30 }}>
          <FaqRow q="So is this another AI slop generator?" open />
          <FaqRow q="Why two gates instead of one big preview?" />
          <FaqRow q="Can I bring my own voice / channel style?" />
          <FaqRow q="What happens when a render fails?" />
          <FaqRow q="Pricing? (you skipped pricing)" />
          <FaqRow q="Shorts?" />
        </div>
      </section>

      <FooterCTA headline="MAKE ONE." sub="9 minutes. 2 free credits. You'll know within the first gate if this is for you." />
      <WfFooter />
      </div>
    </div>
  );
}
